window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.searchResultsItem = `
    <style>
        .product-item a {
            display: block;
            text-decoration: none;
        }

        .product-item a:hover,
        .product-item h4:hover {
            color: #E6007E !important;
        }

        .product-item .foot-space {
            margin-bottom: 63px;
            height: calc(100% - 63px);
        }

        .image-block {
            position: relative;
            width: 100%;
            height: 285px;
            overflow: hidden;
            padding: 16px;
        }

        .image-block img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .product-content {
            position: relative;
            border-top: .5px solid #d1d5db;
            padding: 11px 16px 0;
            height: calc(100% - 285px);
            border-radius: 0 0 4px 4px;
            display: flex;
            flex-direction: column;
        }

        .product-content h4,
        .product-content h4 a {
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            margin-bottom: 12px;
            min-height: 60px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 3;
            text-decoration: none;
            font-family: futura-pt;
            color: #000;
        }

        .product-content h4 a {
            margin-bottom: 0;
        }

        .product-content h4 + label {
            display: block;
            padding-bottom: 20px;
        }

        .product-content .stock-status {
            bottom: 0px;
            background-size: 14px;
            padding-left: 20px;
        }

        .product-content h4 + label .pricing,
        .product-content h4 + label .price-note {
            display: inline-block;
        }

        .product-content h4+label .pricing {
            margin-right: 5px;
        }

        .prod-code,.price-note,.stock-status {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            letter-spacing: .02em;
            color: #666;
            display: inline-block;
            position: relative;
            transition: all .3s ease;
        }

        .prod-code .prod-tooltip {
            position: absolute;
            padding: 4px 5px;
            background: #E6007E;
            top: calc(100% + 5px);
            color: #fff !important;
            font-size: 12px !important;
            line-height: 18px !important;
            transition: all 0.3s ease;
            width: 230px;
            text-align: center;
        }

        .bookmark {
            position: absolute;
            top: 16px;
            right: 16px;
            z-index: 1;
            width: 24px;
            height: 24px;
            background: url(/images/bookmark-icon-grey.svg) no-repeat center / contain;
            cursor: pointer;
            opacity: .6;
        }

        .bookmark:not(.added):hover {
            opacity: 1;
            background: url(/images/bookmark-icon-pink.svg) no-repeat center / contain;
        }

        .pricing {
            font-family: futura-pt;
            font-display: swap;
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            color: #0055a5;
            text-decoration: none;
            text-transform: capitalize;
        }

        .stock-status {
            display: block;
            color: #008342;
            padding-left: 27px;
            background: url(/images/in-stock.svg) no-repeat left center;
        }

        .stock-status {
            font-size: 10px;
            line-height: 20px
        }

        .out-stock {
            color: #DE6B01;
            background: url(/images/out-stock.svg) no-repeat left center;
        }

        .cart-wrap {
            position: absolute;
            width: 100%;
            bottom: 15px;
            left: 0;
            padding: 0 15px;
            margin: 0 auto;
        }

        .flex {
            display: flex;
            flex-wrap: wrap;
        }

        .flex-center-space-between {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
        }

        .cart-wrap:has(.unauthenticated) {
            margin-bottom: 10px;
        }

        .unauthenticated .stock-status {
            background-size: 14px !important;
            padding-left: 18px !important;
            position: absolute;
            min-height: 20px;
        }

        .qty-control {
            border: 1px solid #C4C4C4;
            border-radius: 6px;
            flex-wrap: nowrap;
        }

        .qty-control input {
            font-family: 'futura-pt';
            font-display: swap;
            width: 73px;
            text-align: center;
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            text-align: center;
            letter-spacing: 0.15px;
            color: #747474;
            border: 0;
            border-left: 1px solid #C4C4C4;
            border-right: 1px solid #C4C4C4;
            border-radius: 0;
            appearance: none;
            -webkit-appearance: none;
            padding: 2px;
            height: 30px;
        }

        .qty-control input::-webkit-outer-spin-button,
        .qty-control input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        .qty-control input {
            -moz-appearance: textfield;
        }

        .qty-control button {
            background: #fff;
            text-align: center;
            font-weight: 600;
            border: 0;
            border-radius: 6px;
            color: #747474;
            font-size: 20px;
            width: 22px;
            cursor: pointer;
        }

        .qty-control button.decrease {
            padding-bottom: 4px;
        }

        .add-to-cart {
            display: inline-block;
            text-indent: -900vw;
            width: 36px;
            height: 36px;
            background: url(/images/cart-icon-grey.svg) no-repeat center /contain;
            cursor: pointer;
        }

        .add-to-cart.added {
            background: url(/images/cart-icon-success-green.svg) no-repeat center /contain;
        }

        .featured-category-flag {
            display: block;
            line-height: 1;
            padding: 0;
            margin: 0;
        }

        .featured-category-flag.is-desktop {
            display: block;
        }

        .featured-category-flag.is-mobile {
            display: none;
        }

        .featured-category-flag .flag-text,
        .featured-category-flag .flag-link {
            display: inline-block;
            max-width: 100%;
            padding: 4px 6px;
            background: #E6007E;
            color: #fff !important;
            font-size: 12px !important;
            line-height: 18px !important;
            text-align: left;
            transition: all 0.3s ease;
            margin: 0 !important;
        }

        .product-item .image-block .featured-category-flag {
            position: absolute;
            top: auto;
            right: auto;
            bottom: 12px;
            left: 0;
        }

        .recently-purchased-flag {
            display: block;
            line-height: 1;
            padding: 0;
            margin: 0;
        }

        .recently-purchased-flag.is-desktop {
            display: block;
        }

        .recently-purchased-flag.is-mobile {
            display: none;
        }

        .recently-purchased-flag .flag-text {
            display: inline-block;
            max-width: 100%;
            padding: 4px 6px;
            background: #E6007E;
            color: #fff !important;
            font-size: 12px !important;
            line-height: 18px !important;
            text-align: left;
            transition: all 0.3s ease;
            margin: 0 !important;
        }

        .product-item .image-block .recently-purchased-flag {
            position: absolute;
            top: auto;
            right: auto;
            bottom: 12px;
            left: 0;
        }

        .cable-cut-surcharge {
            display: block;
            align-items: center;
            gap: 8px;
            color: #de6b01 !important;
            font-size: 10px;
            font-weight: 400;
            margin-top: 0;
            margin-bottom: 0 !important;
            height: auto !important;
            width: auto !important;
            position: static !important;
        }

        @media screen and (max-width: 1199px), print {
            .qty-control button {
                width: 24px;
                padding: 0;
            }
            .qty-control input {
                padding: 3px;
                width: 44px;
            }
        }

        @media screen and (max-width: 1024px), print {
            .prod-code {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                -webkit-line-clamp: 1;
            }
        }

        @media screen and (max-width: 767px), print {
            .product-item .image-block {
                height: 200px;
            }

            .product-content {
                height: calc(100% - 200px);
            }

            .prod-code {
                margin-bottom: 8px;
            }

            .price-note, .prod-code, .stock-status {
                font-size: 10px;
                line-height: 18px;
            }
        }

        @media screen and (max-width: 576px), print {
            .product-item .image-block {
                height: 166px;
            }

            .product-content {
                height: calc(100% - 166px);
            }

            .product-item .foot-space {
                margin-bottom: 62px;
                height: calc(100% - 62px);
            }

            .product-item:has(.unauthenticated) .foot-space {
                margin-bottom: 92px;
                height: calc(100% - 92px);
            }

            .product-content h4+label {
                display: flex;
                padding-bottom: 18px;
                line-height: clamp(24px, 1.4vw, 29px);
            }
        }

        @media screen and (min-width: 376px) and (max-width: 440px) {
            .product-item>.foot-space>.product-content>label {
                padding-bottom: 0 !important;
            }

            .stock-status:not(.out-stock) {
                background-position: left 0 top 1px;
                min-height: 20px;
            }

            .product-content .stock-status {
                position: static;
                margin-bottom: 4px;
            }
        }

        @media screen and (max-width: 424px), print {
            .product-item:not(.unauthenticated) .stock-status {
                line-height: 14px;
                margin-top: 5px;
            }
        }
    </style>
    <div class="product-item">
        {{#if (eq type "product")}}
            {{#if (lt salePrice price)}}
            <span class="search-results-list__item__sale-indicator">{{strings.sale}}</span>
            {{/if}}
            <a hawksearch-link href="{{url}}" class="search-results-list__item__image" aria-label="{{title}}">
                <img hawksearch-image src="{{imageUrl}}" alt="" />
            </a>
            <div class="search-results-list__item__title">
                <a hawksearch-link href="{{url}}">{{title}}</a>
            </div>
            {{#unless (eq price undefined)}}
            <div class="search-results-list__item__price" itemprop="offers" itemtype="http://schema.org/Offer"
                itemscope>
                {{#if (lt salePrice price)}}
                <span class="search-results-list__item__price__original">{{currency price}}</span>
                <span class="search-results-list__item__price__current" itemprop="price">{{currency salePrice}}</span>
                {{else}}
                <span class="search-results-list__item__price-__current" itemprop="price">{{currency price}}</span>
                {{/if}}
            </div>
            {{/unless}}
            <hawksearch-variant-selector></hawksearch-variant-selector>
        {{else}}
            {{#if (isLoggedIn)}}
                <a onclick="hawksearchProductListing.addToJobList(event)"
                    data-productname={{title}}
                    data-productcode={{attributes.product_pronto_code}}
                    data-productqty={{attributes.product_default_quantity}}
                    data-productprice={{attributes.product_price}}
                    class="bookmark add-to-joblist"></a>
                {{#if (getJobListPermission)}}

                {{else}}
                <span class="permission-message">Please contact your Account Admin to request Joblist access.</span>
                {{/if}}
            {{else}}
                <span class="bookmark loginproductcode" data-productname={{title}}
                    data-productcode={{attributes.product_pronto_code}} data-productqty={product.currentQty}
                    data-productprice={product.currentPrice}
                    onclick="hawksearchProductListing.showLoginPopup(event)"></span>
            {{/if}}

            <a hawksearch-link href="{{productUrl attributes.product_name attributes.product_pronto_code}}"
                aria-label="{{title}}" class="foot-space">
                <div class="image-block">
                    <img hawksearch-image src="{{productImageUrl imageUrl 280 180}}" alt="" />
                    {{#if (isRecentlyPurchasedItem attributes.product_pronto_code)}}
                        <div class='recently-purchased-flag '>
                            <span class="flag-text">Recently Purchased</span>
                        </div>
                    {{else}}
                        {{#if (isMiddysEssentialsItem attributes.featured_product_group_name)}}
                            <div class='featured-category-flag'>
                                <span class="flag-text">Middy's Essentials</span>
                            </div>
                        {{/if}}
                    {{/if}}
                </div>
                <div class="product-content">
                    <span class="prod-code" data-size="144px"
                        onmouseover="hawksearchProductListing.onProdCodeMouseOver(event)"
                        onmouseout="hawksearchProductListing.onProdCodeMouseOut(event)">{{attributes.product_attr_middys_code}}
                        ({{attributes.product_pronto_code}})</span>
                    <h4>{{attributes.product_display_name}}</h4>
                    {{#if (isLoggedIn)}}
                        <label>
                            <span class="pricing">\${{attributes.product_price}}</span>
                            {{#if (eq attributes.product_attr_unit_of_measure undefined)}}
                                <span class="price-note">per unit (ex. GST)</span>
                            {{else}}
                                <span class="price-note">per {{attributes.product_attr_unit_of_measure}} (ex. GST)</span>
                            {{/if}}
                        </label>
                    {{/if}}

                    {{#unless (eq attributes.inventory undefined)}}
                        {{#if (gt (number attributes.inventory.product_stock) 0)}}
                            <span class="stock-status">{{attributes.inventory.stock_status_msg}} ({{attributes.inventory.product_stock}} {{attributes.inventory.product_uom_plural}} Available)</span>
                        {{else}}
                            {{#if (eq attributes.inventory.stock_img_ind 'N')}}
                                <span class="stock-status out-stock">{{attributes.inventory.stock_status_msg}}</span>
                            {{else}}
                                <span class="stock-status">{{attributes.inventory.stock_status_msg}}</span>
                            {{/if}}
                        {{/if}}
                    {{/unless}}

                    {{#if (isCableProduct attributes.product_attr_product_group)}}
                        <span class="cable-cut-surcharge">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                stroke="#de6b01"
                                strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                                <line x1="12" y1="9" x2="12" y2="13" />
                                <line x1="12" y1="17" x2="12.01" y2="17" />
                            </svg>
                            Unit Price for 100mtr + only
                        </span>
                    {{/if}}
                </div>
            </a>
            {{#if (isLoggedIn)}}
                <div class="cart-wrap flex-center-space-between">
                    <div class="qty-control flex">
                        <button class="decrease">-</button>
                        <input
                            type="number"
                            name="qty-count"
                            min="{{attributes.product_default_quantity}}"
                            value="{{attributes.product_default_quantity}}"
                            id="qty-count"
                        />
                        <button class="increase">+</button>
                    </div>
                    <a href="#"
                        class="add-to-cart addtocart"
                        data-productname={{title}}
                        data-productcode={{attributes.product_pronto_code}}
                        data-productqty={{attributes.product_default_quantity}}
                        data-productprice={{attributes.product_price}}
                        onclick="event.preventDefault(); hawksearchProductListing.addToCart(this);"
                    >Add to cart</a>
                </div>
            {{else}}
                <div class="cart-wrap flex-center-space-between">
                    <div class="unauthenticated">
                        <a href="#" class="pricing"
                            onclick="event.preventDefault(); hawksearchProductListing.showLoginPopup();">Log In For Price
                        </a>
                    </div>
                </div>
            {{/if}}
            <hawksearch-variant-selector></hawksearch-variant-selector>
        {{/if}}
    </div>
`;
